<template>
  <v-row>
    <v-col cols="12">
      <v-toolbar color="white" flat>
        <v-toolbar-title class="grey--text text-h4 text--darken-4">
          Balance Sheet
        </v-toolbar-title>
      </v-toolbar>
    </v-col>
    <v-col class="m-0 pb-0" cols="12" sm="4">
      <date-range-picker @onDates="onDatesSelected"/>
    </v-col>
    <v-col cols="12">
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-right">Amount</th>
              <th class="text-left">Account</th>
              <th class="text-right"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="balanceSheet.entries.length == 0">
              <td colspan="3" >No entries in the system</td>
            </tr>
            <tr v-for="entry in balanceSheet.entries" :key="entry.uuid">
              <td class="text-right">{{ entry.amount | formatAmount }}</td>
              <td>{{ entry.account.obj().fname }}</td>
              <td></td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-col>
  </v-row>
</template>

<script>
import DateRangePicker from './common/DateRangePicker.vue';

export default {
  name: "BalanceSheet",
  components: { DateRangePicker },
  data() {
    return {
      lines: [],
      selectedDates:[],
    };
  },
  computed: {
    balanceSheet() {
      const bs = this.$store.getters["getBalanceSheet"](this.selectedDates) || {};
      const entries = bs.entries || [];
      return {
        entries: entries.sort((e1, e2) => {
          return e1.account.obj().fname.localeCompare(e2.account.obj().fname);
        }),
      };
    },
  },
  methods: {
    onDatesSelected(dates) {
      this.selectedDates = dates.map(d => new Date(d));
    },
  },
  async created() {
    await this.$store.dispatch("getTransactions");
  },
};
</script>